import { render } from "./PositionList.vue?vue&type=template&id=21b3bf00"
import script from "./PositionList.vue?vue&type=script&lang=js"
export * from "./PositionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__